import styles from "../../ProductsRPDesigner.module.scss";

function GSColors({
  colorFont,
  colorBackground,
  changeGlobalColorFont,
  changeGlobalColorBackground,
}) {
  return (
    <div
      data-tour="rpdesigner-step-1"
      className={styles["sec--products--rpdesigner--colors"]}
    >
      <div className={styles["sec--products--rpdesigner--colors--element"]}>
        <div
          className={styles["sec--products--rpdesigner--colors--element--left"]}
        >
          {colorFont.label}
        </div>
        <div>
          <input
            type="color"
            id={colorFont.id}
            name={colorFont.id}
            value={colorFont.value}
            onChange={(e) => changeGlobalColorFont(e.target.value)}
          />
        </div>
      </div>

      <div className={styles["sec--products--rpdesigner--colors--element"]}>
        <div
          className={styles["sec--products--rpdesigner--colors--element--left"]}
        >
          {colorBackground.label}
        </div>
        <div>
          <input
            type="color"
            id={colorBackground.id}
            name={colorBackground.id}
            value={colorBackground.value}
            onChange={(e) => changeGlobalColorBackground(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

export default GSColors;